import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  VillagePayloadSchema,
  useVillage,
  villagePayloadSchema,
} from "@/api/village";
import { Loading } from "@/components/ui/loading";
import { VillageFormFields } from "./VillageFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function VillageDetailForm({ id }: { id: string }) {
  const {
    data: village,
    isPending: isLoadingData,
    isError,
  } = useVillage({
    id,
  });
  const form = useForm<VillagePayloadSchema>({
    resolver: zodResolver(villagePayloadSchema),
    defaultValues: {
      villageCode: village?.villageCode,
      villageName: village?.villageName,
      subdistrict: village?.subdistrict,
    },
    values: village,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!village) {
    return <div>Sub District not found</div>;
  }

  if (isError) {
    return <div>Failed to load Sub District</div>;
  }

  return (
    <FormContainer form={form}>
      <VillageFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/subdistrict" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
